import { useParams } from "react-router";
import { ClassifierBuilderV2Store } from "../../Stores/ClassifierBuilderV2Store";
import { useStore } from "utils/useStore";
import { Grid, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import ClassifierBuilderDetails from "../../Views/Builder/ClassifierBuilderV2Details";
import ClassifierBuilderRuleset from "../../Views/Builder/ClassifierBuilderV2Ruleset";
import { AuthStore } from "stores/AuthStore";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import ClassifierBuilderV2Toolbar from "./ClassifierBuilderV2Toolbar";
import ClassifierCategory from "models/ClassifierCategoryId";
import ClassifierGroup from "models/ClassifierGroup";

const ClassifierBuilderTableV2Edit = observer(() => {
    const theme = useTheme();
    const store = useStore(ClassifierBuilderV2Store);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState<ClassifierCategory | null>(null);
    const [group, setGroup] = useState<ClassifierGroup>();
    const authStore = useStore(AuthStore);
    const orgStore = authStore.orgStore;
    const { id } = useParams();

    const onSave = async () => {
        if (id) {
            try {
                store.setTestClassifierError("");
                await store.validateRbcFtsSearchString();
                store.isRbcFtsStringValid &&
                    !store.testClassifierError &&
                    store.updateClassifier(
                        name,
                        store.rbcSearchTermStr,
                        id,
                        description,
                        category,
                        group,
                    );
            } catch (error) {
                throw error;
            }
        }
    };

    useEffect(() => {
        if (orgStore && orgStore.selectedOrganization && store && id) {
            store.orgSelectStore.selectOrg(orgStore.selectedOrganization);
            store.setSelectedClassifier(id);
        } else {
            store.clearSelectedClassifier();
        }
    }, [orgStore, orgStore?.selectedOrganization, store, id]);

    useEffect(() => {
        if (store.selectedClassifier) {
            setName(store.selectedClassifier.name);
            setDescription(store.selectedClassifier.description);
            setCategory(store.selectedClassifier.classifierCategory);
            setGroup(store.selectedClassifier.classifierGroup);
            store.setRbcSearchTermStr(
                store.rbcSearchTermStr
                    ? store.rbcSearchTermStr
                    : store.selectedClassifier.classifierImplementations[0]
                          ?.queryString ?? "",
            );
        }
    }, [
        store,
        store.selectedClassifier,
        store.selectedClassifier?.classifierImplementations,
    ]);

    return (
        <Grid container direction="column">
            <Grid item>
                <ClassifierBuilderV2Toolbar
                    store={store}
                    onSave={onSave}
                    disableSave={!store.selectedClassifier}
                />
            </Grid>
            <Grid
                item
                container
                wrap="nowrap"
                direction="column"
                sx={{
                    paddingLeft: theme.spacing(20),
                    paddingRight: theme.spacing(20),
                    paddingTop: theme.spacing(3),
                    height: "calc(100% - 64px)",
                }}
                rowGap={2}
            >
                {store.selectedClassifier ? (
                    <>
                        <ClassifierBuilderDetails
                            name={name}
                            description={description}
                            category={category}
                            group={group}
                            onNameChange={(e) => {
                                setName(e.target.value);
                            }}
                            onDescriptionChange={(e) => {
                                setDescription(e.target.value);
                            }}
                            onCategoryChange={(cat) => {
                                if (cat.name === "No Selection") {
                                    setCategory(null);
                                } else {
                                    setCategory(cat);
                                }
                            }}
                            onGroupChange={setGroup}
                            modifiedOn={store.selectedClassifier?.modifiedOn}
                            isSmartPredictActive={
                                store.selectedClassifier
                                    ?.classifierResultAnswerTags.length > 1
                            }
                        />
                        <ClassifierBuilderRuleset />
                    </>
                ) : store.getTaskLoading(
                      ClassifierBuilderV2Store.Tasks.UpdateClassifier,
                  ) || store.isClassifierListLoading ? (
                    <AcxLoadingIndicator size={24} alternate="PuffLoader" />
                ) : null}
            </Grid>
        </Grid>
    );
});

export default ClassifierBuilderTableV2Edit;
